import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { initializeAnalytics, trackPageView } from "../lib/analytics";

function AnalyticsTracker() {
  const location = useLocation();

  useEffect(() => {
    initializeAnalytics();
  }, []);

  useEffect(() => {
    const path = `${location.pathname}${location.search || ""}`;
    trackPageView({
      path,
      title: typeof document !== "undefined" ? document.title : "",
    });
  }, [location.pathname, location.search]);

  return null;
}

export default AnalyticsTracker;
